import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';

import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable
} from '@dnd-kit/sortable';

import { CSS } from '@dnd-kit/utilities';

import { getDisplaySelectedFieldName } from '../../i18n';

import { DragHandleIcon } from '../../constants/images';

import theme from '../../theme';


const SortableItem = ({ media, field, w01Color, disabled, reportLanguage, getLocalizedFieldName, intl }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: field.expression
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '8px',
    padding: '4px 8px',
    color: disabled ? theme.palette.grey.w300 : 'inherit',
    border: `1px solid ${theme.palette.grey.w200}`,
    borderRadius: '4px',
    backgroundColor: isDragging ? w01Color : '#fff',
    cursor: 'grab',
    '&:hover': {
      backgroundColor: w01Color
    },
  };

  return (
    <Box ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <DragHandleIcon />
      <Typography sx={{ marginLeft: '8px' }}>
        {getLocalizedFieldName(media, field, reportLanguage, intl)}
      </Typography>
    </Box>
  )
}

const SortFieldsDragDropKit = ({ media, allSortFields, setAllSortFields, w01Color, reportLanguage, getLocalizedFieldName, intl }) => {
  const processedFields = allSortFields.map((field, index) => ({
    ...field,
    indexNumber: field.indexNumber ?? index
  }))

  const handleDragEnd = (e) => {
    const { active, over } = e; // active: 被拖曳的項目、over: 新位置的索引

    if (!active || !over || active.id === over.id) return;

    // 獲取 'reach' 的 field (觸及人數)
    const reachField = processedFields.find((field) => field.expression === "reach");
    const otherFields = processedFields.filter((field) => field.expression !== "reach");

    const oldIndex = otherFields.findIndex((field) => field.expression === active.id);
    const newIndex = otherFields.findIndex((field) => field.expression === over.id);

    if (active.id === "reach") return; // 禁止固定項目拖曳

    // 移動非 'reach' 的元素
    const newSortFields = arrayMove(otherFields, oldIndex, newIndex);

    // 更新 indexNumber，並確保 'reach' 在最後
    const updateFields = [
      ...newSortFields.map((field, index) => ({
        ...field,
        indexNumber: index, // 重新排序非 reach 項目的 indexNumber
      })),
      ...(media === 'FACEBOOK' ? [{ ...reachField, indexNumber: 300 }] : []), // 確保 reach 在最後且 indexNumber = 300
    ];

    setAllSortFields(updateFields);
  };

  return (
    <DndContext onDragEnd={handleDragEnd}>
      <SortableContext items={processedFields.map((field) => field.expression)}>
        {processedFields.map((field) => (
          <SortableItem
            meida={media}
            key={field.expression}
            field={field}
            w01Color={w01Color}
            reportLanguage={reportLanguage}
            disabled={field.expression === 'reach'} // FB觸及人數不可拖曳
            getLocalizedFieldName={getLocalizedFieldName}
            intl={intl}
          />
        ))}
      </SortableContext>
    </DndContext>
  )
}

export default SortFieldsDragDropKit;